import React from "react";
import { Button, Typography, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

type Props = {};

const features = [
  "Create a cleaner, greener future.",
  "Divert recyclable materials from landfills.",
  "Reduce environmental pollution.",
  "Foster a circular economy.",
];

const About = (props: Props) => {
  return (
    <Box id="about">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 4, md: 8 },
          px: { xs: 2, md: 8 },
          py: { xs: 4, md: 8 },
          justifyContent: "space-between",
          bgcolor: "#F5F6F4",
          borderRadius: "20px",
          flexDirection: { xs: "column", md: "row" },
        }}
        data-aos="fade-up"
      >
        <Box sx={{ flex: 1, minWidth: 280 }}>
          <Typography
            variant="subtitle2"
            sx={{ color: "#6B6B6B", fontWeight: 500, letterSpacing: 1, mb: 1 }}
          >
            About Us
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              mb: 2,
              lineHeight: 1.3,
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            We are a leading recycling company dedicated to transforming how
            Nigeria manages its waste.
          </Typography>
          <Box component="ul" sx={{ pl: 0, mb: 3, listStyle: "none" }}>
            {features.map((item, idx) => (
              <Box
                component="li"
                key={idx}
                sx={{ display: "flex", alignItems: "center", mb: 1.5 }}
              >
                <CheckCircleIcon
                  sx={{ color: "#8A9A5B", mr: 1 }}
                  fontSize="small"
                />
                <Typography variant="body1">{item}</Typography>
              </Box>
            ))}
          </Box>
          <Button
            variant="contained"
            className="learn-more-button"
            sx={{
              backgroundColor: "rgba(138, 154, 91, 1)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
                color: "rgba(138, 154, 91, 1)",
              },
              borderRadius: "50px",
              padding: "10px 20px",
              fontSize: "16px",
            }}
          >
            Learn More{" "}
            <img
              src={require("../../Assets/arrow.png")}
              alt="arrow"
              className="ml-2 arrow-icon"
              style={{ width: "5vmin" }}
            />
          </Button>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            component="img"
            src={require("../../Assets/mockup.png")}
            alt="mockup"
            sx={{
              width: { xs: "90%", md: "80%" },
              borderRadius: "18px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
      <Box sx={{ backgroundColor: "#F5F6F4" }} id="services">
        <Typography
          variant="h6"
          align="center"
          sx={{
            fontWeight: 500,
            color: "#6B6B6B",
            mb: 4,
            letterSpacing: 1,
            backgroundColor: "#F5F6F4",
            pt: 2,
            fontSize: { xs: 20, md: 24 },
          }}
        >
          How we work
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-around",
            alignItems: "center",
            backgroundImage: `url(${require("../../Assets/bg.png")})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            height: { xs: "auto", md: 500 },
            margin: 0,
            padding: { xs: 2, md: 0 },
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              width: "100%",
              maxWidth: "300px",
              height: "auto",
              minHeight: "300px",
              borderRadius: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 20,
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              justifyContent: "space-around",
              marginBottom: "20px",
            }}
          >
            <img
              src={require("../../Assets/recycle.png")}
              alt="recycle"
              style={{
                width: "10vmin",
                height: "10vmin",
                objectFit: "cover",
                borderRadius: "20px",
              }}
            />
            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  fontFamily: "Arial",
                  color: "rgba(69, 72, 57, 1)",
                }}
              >
                Recycle Waste{" "}
              </Typography>
              <Typography variant="body1" sx={{ color: "rgba(80, 80, 80, 1)" }}>
                We collect and repurpose used paper from both public recycling
                bins and through partnerships with businesses that generate
                large quantities of paper waste.
              </Typography>
            </Box>
          </div>
          <div
            style={{
              backgroundColor: "white",
              width: "100%",
              maxWidth: "300px",
              height: "auto",
              minHeight: "300px",
              borderRadius: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 20,
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              justifyContent: "space-around",
              marginBottom: "20px",
            }}
          >
            <img
              src={require("../../Assets/produce.png")}
              alt="recycle"
              style={{
                width: "10vmin",
                height: "10vmin",
                objectFit: "cover",
                borderRadius: "20px",
              }}
            />
            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  fontFamily: "Arial",
                  color: "rgba(69, 72, 57, 1)",
                }}
              >
                Produce{" "}
              </Typography>
              <Typography variant="body1" sx={{ color: "rgba(80, 80, 80, 1)" }}>
                We are committed to giving discarded materials a new life. We
                recycle all paper into a wide range of new products, including
                various types of paper bags and more.
              </Typography>
            </Box>
          </div>
          <div
            style={{
              backgroundColor: "white",
              width: "100%",
              maxWidth: "300px",
              height: "auto",
              minHeight: "300px",
              borderRadius: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 20,
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              justifyContent: "space-around",
              marginBottom: "20px",
            }}
          >
            <img
              src={require("../../Assets/distribute.png")}
              alt="recycle"
              style={{
                width: "10vmin",
                height: "10vmin",
                objectFit: "cover",
                borderRadius: "20px",
              }}
            />
            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  fontFamily: "Arial",
                  color: "rgba(69, 72, 57, 1)",
                }}
              >
                Distribute{" "}
              </Typography>
              <Typography variant="body1" sx={{ color: "rgba(80, 80, 80, 1)" }}>
                We deliver our new products directly to our retail partners and
                other commercial clients. This direct approach allows us to
                maintain greater control over the entire supply chain.
              </Typography>
            </Box>
          </div>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 4, md: 8 },
          px: { xs: 2, md: 8 },
          py: { xs: 4, md: 8 },
          justifyContent: "space-between",
          bgcolor: "#F5F6F4",
          borderRadius: "20px",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box sx={{ flex: 1, maxWidth: "80%", textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 2,
              lineHeight: 1.3,
              textAlign: "center",
            }}
          >
            Transform Nigeria with us
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "rgba(80, 80, 80, 1)", mb: 3 }}
          >
            As a large organization or business, you have the power to make a
            significant impact. Partner with us to revolutionize Nigeria's waste
            management system and build a cleaner, more sustainable future for
            all.
          </Typography>
          <Button
            variant="contained"
            className="learn-more-button"
            sx={{
              backgroundColor: "rgba(138, 154, 91, 1)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
                color: "rgba(138, 154, 91, 1)",
              },
              borderRadius: "50px",
              padding: "10px 20px",
              fontSize: "16px",
            }}
          >
            Learn More{" "}
            <img
              src={require("../../Assets/arrow.png")}
              alt="arrow"
              className="ml-2 arrow-icon"
              style={{ width: "5vmin" }}
            />
          </Button>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            component="img"
            src={require("../../Assets/helmets.png")}
            alt="mockup"
            sx={{
              width: { xs: "90%", md: "80%" },
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default About;
